import { Upload, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { fileDetail } from '@/apis/public';
import styles from './UploadImg.module.scss'
import { CloseCircleOutlined } from '@ant-design/icons';
import React from 'react';
const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
const UploadImg = ({ fileList, setFileList, fileId, propKey, changeImg }) => {
	const [previewImage, setPreviewImage] = useState('');
	const [previewOpen, setPreviewOpen] = useState(false);
	const [imgPath, setImgPath] = useState('')
	const handlePreview = async (file) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}
		setPreviewImage(file.url || file.preview);
		setPreviewOpen(true);
	};
	const props = {
		accept: ".png, .jpg, .jpeg, .webp",
		limit: 1,
		onChange(info) {
			setFileList(info.fileList)
		},
		customRequest(options) {
			const { onSuccess, file } = options;
			onSuccess('上传成功', file);
		},
		onPreview: handlePreview,
	};

	const getImgPath = () => {
		fileDetail({
			fileUuid: fileId[propKey]
		}).then(res => {
			setImgPath(process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + res.data.filePath)
		})
	}
	useEffect(() => {
		if (fileId[propKey]) {
			getImgPath()
		}
	}, [fileId[propKey]])
	const uploadButton = (
		<button
			style={{ border: "none", background: 'none' }} type="button">
			<PlusOutlined />
			<div style={{ marginTop: 8 }} > 上传 </div>
		</button>
	);

	const deleteImg = () => {
		setImgPath('')
		changeImg({
			...fileId,
			[propKey]: ""
		})
	}
	return <div>
		{imgPath &&
			<div className={styles.imgBox}>
				<CloseCircleOutlined onClick={deleteImg} />
				<Image
					width={100}
					src={imgPath}
				/>
			</div>
		}
		{
			!imgPath && <React.Fragment>
				<Upload
					listType="picture-card"
					fileList={fileList}
					{...props}
				>
					{fileList.length >= 1 ? null : uploadButton}
				</Upload>
				{previewImage && (
					<Image
						wrapperStyle={{
							display: 'none',
						}}
						preview={{
							visible: previewOpen,
							onVisibleChange: (visible) => setPreviewOpen(visible),
							afterOpenChange: (visible) => !visible && setPreviewImage(''),
						}}
						src={previewImage}
					/>
				)}
			</React.Fragment>
		}
	</div>
}
export default UploadImg;